<template>
  <div class="vipDrop">
    <div class="title">
      <span>加入个人VIP，可享受</span>
    </div>
    <div class="list-body">
      <div class="body">
        <img
          :style="{ width: '28px', height: '28px' }"
          src="../../../static/svg/topNav/01.svg"
          alt
        />
        <div class="details">
          <span class="details-title">125000+个精品原创模板</span>
          <span class="details-content">每日实时更新，多场景全覆盖</span>
        </div>
      </div>

      <div class="body">
        <img
          :style="{ width: '28px', height: '28px' }"
          src="../../../static/svg/topNav/02.svg"
          alt
        />
        <div class="details">
          <span class="details-title">1800万+正版素材可商用</span>
          <span class="details-content">角色、背景、字体元素</span>
        </div>
      </div>

      <div class="body">
        <img
          :style="{ width: '28px', height: '28px' }"
          src="../../../static/svg/topNav/03.svg"
          alt
        />
        <div class="details">
          <span class="details-title">导出特权</span>
          <span class="details-content">视频无水印、1080P高清、时长无限制</span>
        </div>
      </div>

      <div class="body">
        <img
          :style="{ width: '28px', height: '28px' }"
          src="../../../static/svg/topNav/04.svg"
          alt
        />
        <div class="details">
          <span class="details-title">创作特权</span>
          <span class="details-content">仿真配音 一键抠图</span>
        </div>
      </div>
    </div>
    <div class="bottom-grid">
      <div
        @click="joinVip()"
        class="join-vip"
        :class="{ haveVipActivity: haveVipActivity }"
      >
        <img
          v-if="haveVipActivity"
          :style="{ width: '28px', height: '28px' }"
          src="../../../static/svg/topNav/05.svg"
          alt
        />
        <!-- <span>{{ activityTitle }}</span> -->
        <span>开通企业会员</span>
      </div>
      <!-- <div @click="joinVip()" class="join-vip">立即加入VIP</div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "vipDrop",
  data() {
    return {
      haveVipActivity: false,
      activityType: "",
      activityTitle: "",
    };
  },
  props: {},
  components: {},
  methods: {
    joinVip() {
      this.$util.localStorage.set("sensorWebPurchaseVipSource", {
        val: {
          routename: "tool",
          page: "编辑器-会员升级",
        },
      });
      this.$util.localStorage.set("sensorWebPayVipSource", {
        val: {
          routename: "tool",
          page: "编辑器-会员升级",
        },
      });
      this.$util.localStorage.set("saPurchaseSource", {
        fullPath: "/tool",
      });
      // let eventName = this.openSubtitle ? "subtitlePopup" : "FeaturesPop_vue";
      // window.open("/workplace/pvip?source=2&page=19", "_blank");
      // this.$bus.emit(eventName, {
      //   name: "vipPayment",
      //   msg: "请在相应的付款页面进行操作",
      //   btnClose: "遇到问题",
      //   btnMsg: "付款成功",
      //   fs: "payPriceEvent_vue",
      //   msgType: 2,
      //   type: 2,
      // });
      this.$memberGuide({
        show: true,
        context: this,
        funcRight: {
          type: '',
          name: '',
        },
      });
    },
    getActivityContent(vipActivity) {
      let discount = Math.round(
        (parseFloat(vipActivity.price) /
          parseFloat(vipActivity.originalPrice)) *
          10
      );
      let averagePrice = vipActivity.price / (12 * 31);
      averagePrice = parseFloat(averagePrice.toFixed(1));
      if (discount >= 10) {
        this.activityTitle = "立即加入,每天低至" + averagePrice + "元";
        this.haveVipActivity = false;
      } else {
        this.activityTitle =
          "限时特惠" +
          parseFloat(discount) +
          "折,每天低至" +
          averagePrice +
          "元";
        this.haveVipActivity = true;
      }
    },
    async getVipActivity() {
      const vm = this;
      this.$http
        .get("/api/user/vipLevelInfo?levelType=0&platform=0")
        .then((res) => {
          if (res.data.code === 200) {
            let datas = res.data.data;
            for (const i in datas) {
              let data = datas[i];
              for (const j in data) {
                let info = data[j];
                if (info.levelType == 0 && info.month == 12) {
                  vm.getActivityContent(info);
                }
              }
            }
          }
        });
    },
  },
  created() {
    this.getVipActivity();
  },
  watch: {},
  computed: {
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
    }),
  },
};
</script>

<style scoped lang="scss">
.vipDrop {
  display: flex;
  flex-direction: column;
  padding: 30px 28px 32px 30px;
  background-color: #fff;
  border: 0 solid black;
}

.title {
  display: flex;
  align-items: center;
  line-height: 21px;
  color: #333;
  font-size: 16px;
  text-align: left;
  margin-bottom: 24px;
  .discount {
    display: inline-block;
    min-width: 50px;
    height: 14px;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: 8px;
    color: #fff;
    font-size: 10px;
    font-weight: normal;
    line-height: 14px;
    text-align: center;
    background: #ea3d45;
    border-radius: 4px;
  }
}
.list-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  margin-bottom: 14px;
  .body {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    width: 100%;
    margin-bottom: 20px;
    .icon {
      width: 28px;
      height: 28px;
      margin-top: 2px;
    }
    .details {
      flex-grow: 1;
      margin-left: 8px;
      > span {
        display: block;
        width: 100%;
        font-size: 14px;
        line-height: 19px;
        text-align: left;
      }
      .details-title {
        color: #333;
        font-weight: bold;
        margin-bottom: 4px;
      }
      .details-content {
        color: #999;
      }
    }
  }
}

.bottom-grid {
  position: relative;

  .time-limit-ad {
    color: #bb9029;
    font-size: 12px;
  }
  .join-vip {
    width: 250px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(134deg, #77a3f7 0%, #2b48e2 100%);
    border-radius: 4px;
    font-weight: bold;
    color: #ffffff;
    &:hover {
      background: linear-gradient(
        134deg,
        rgba(119, 163, 247, 0.8) 0%,
        rgba(43, 72, 226, 0.8) 100%
      );
    }
    &.haveVipActivity {
      background: linear-gradient(90deg, #fbe6c3 0%, #dfb17c 100%);
      color: #876030;
      &:hover {
        background: linear-gradient(
          90deg,
          rgba(251, 230, 195, 0.8) 0%,
          rgba(223, 177, 124, 0.8) 100%
        );
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/vipDrop.vue